// extracted by mini-css-extract-plugin
export default {"navTag":"MIursmnH"};